export const appConfig = {
    storeState: "simple-notes",
};
